// import React, { useEffect } from "react";
// import Typed from "typed.js";
// import hero_bg from "../assets/hero_bg.jpg"

// const PageHeader = ({ title, breadcrumb }) => {
//   useEffect(() => {
//     const typed = new Typed('.typing', {
//       strings: [title], // The dynamic title
//       typeSpeed: 20, // Typing speed
//       loop: false, // Disable looping
//       showCursor: false, // Hide the cursor
//     });

//     return () => {
//       typed.destroy(); // Clean up the Typed.js instance
//     };
//   }, [title]);

//   return (
//     <section className="relative h-[500px] w-full overflow-hidden">
//       {/* Background Image */}
//       <div
//         className="absolute inset-0 bg-cover bg-center bg-no-repeat"
//         style={{
//           backgroundImage: `url(${hero_bg})`,
//         }}
//       />

//       {/* Blue Overlay with Opacity */}
//       <div className="absolute inset-0 bg-blue-900 opacity-80"></div>

//       {/* Content */}
//       <div className="relative flex h-full flex-col items-center justify-center text-white">
//         {/* Typing Effect for Title */}
//         <h1 className="mb-4 text-5xl font-bold tracking-wide">
//           <span className="typing"></span>
//         </h1>

//         {/* Breadcrumb */}
//         <nav className="flex items-center space-x-2 text-lg">
//           <a href="/" className="transition-opacity hover:opacity-80">
//             Home
//           </a>
//           <span className="opacity-70">›</span>
//           <span className="opacity-70">{breadcrumb}</span>
//         </nav>
//       </div>
//     </section>
//   );
// };

// export default PageHeader;

import React, { useEffect } from "react";
import Typed from "typed.js";
import hero_bg from "../assets/hero_bg.jpg"

const PageHeader = ({ title, breadcrumb }) => {
  const breadcrumbArray = Array.isArray(breadcrumb) ? breadcrumb : [];

  return (
    <section className="relative h-[500px] w-full overflow-hidden">
      {/* Background Image */}
      <div
        className="absolute inset-0 bg-cover bg-center bg-no-repeat"
        style={{
          backgroundImage: `url(${hero_bg})`,
        }}
      />

      {/* Blue Overlay with Opacity */}
      <div className="absolute inset-0 bg-blue-900 opacity-80"></div>

      {/* Content */}
      <div className="relative flex h-full flex-col items-center justify-center text-white">
        {/* Typing Effect for Title */}
        <h1 className="mb-4 text-5xl font-bold tracking-wide">
          <span className="typing">{title}</span>
        </h1>

        {/* Breadcrumb */}
        <nav className="flex items-center space-x-2 text-lg">
          {breadcrumbArray.length > 0 ? (
            breadcrumbArray.map((crumb, index) => (
              <React.Fragment key={index}>
                <a href={crumb.path} className="transition-opacity hover:opacity-80">
                  {crumb.label}
                </a>
                {index < breadcrumbArray.length - 1 && <span className="opacity-70">›</span>}
              </React.Fragment>
            ))
          ) : (
            <span>No breadcrumb available</span> // Placeholder if breadcrumb is empty
          )}
        </nav>
      </div>
    </section>
  );
};


export default PageHeader;

